import React from "react";
import styles from './OwnStatusBlock.module.scss'
import {
    OWN_STATUS_ERROR,
    OWN_STATUS_LISTENING,
    OWN_STATUS_LOADING,
    OWN_STATUS_SUCCESS
} from "../../../../../settings/content/deploymentOwn";
import Loading from "../../../../../components/Loading";

function OwnStatusBlock({status, statusMessage}) {

    let icon = '';
    let color = '';

    switch (status) {
        case OWN_STATUS_SUCCESS:
            icon = 'fas fa-check';
            color = `var(--colorFontSuccess)`;
            break;
        case OWN_STATUS_ERROR:
            icon = 'fas fa-exclamation';
            color = `var(--colorFontError)`;
            break;
        default:
            icon = 'fas fa-pause';
            color = `var(--colorFontWarning)`;
            break;
    }

    return (
        <div className={styles.status} style={{'--own-status-color': color}}>
            {
                (
                    status === OWN_STATUS_LISTENING
                    || status === OWN_STATUS_LOADING
                )
                    ?
                    <Loading
                        className={styles.status__loading}
                        circleDiameter={`40px`}
                        icon={{
                            faCode: status === OWN_STATUS_LISTENING ? 'fas fa-link' : 'fas fa-chevron-down',
                            animationType: 'bottom',
                        }}
                        colorCircle={color}
                    />
                    :
                    <i className={`${icon} ${styles.status__icon}`}/>
            }
            <div className={styles.status__text}>
                <p className={styles.status__text__title}>Connect your server</p>
                <p className={styles.status__text__message}>{statusMessage}</p>
            </div>
        </div>
    )
}

export default OwnStatusBlock